import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { useWorkspaceId, WorkspaceWritable } from "../workspaceId";
import { MoreButton } from "@/src/common/MoreButton";
import { OrgButton } from "../OrgButton";
import { useLayoutContext } from "arkh";
import { graphql, useMutation } from "react-relay";
import { useCallback } from "react";
import { RoutineEditParams } from "../../RoutineAdmin/RoutineEditMain/RoutineEditNavigation";
import { WorkspaceComplianceRoutinesCreateButtonMutation } from "./__generated__/WorkspaceComplianceRoutinesCreateButtonMutation.graphql";

export function WorkspaceComlianceRoutinesCreateButton(props: {
  openRoutineEdit: (state: RoutineEditParams) => void;
}) {
  const workspaceId = useWorkspaceId();
  const [createRoutineMutation] =
    useMutation<WorkspaceComplianceRoutinesCreateButtonMutation>(graphql`
      mutation WorkspaceComplianceRoutinesCreateButtonMutation(
        $workspaceId: ID!
      ) {
        workspace(id: $workspaceId) {
          createRoutine {
            id
          }
        }
      }
    `);

  const createRoutine = useCallback(
    (freq: "monthly" | "weekly" | "daily") => {
      createRoutineMutation({
        variables: {
          workspaceId,
        },
        onError(error) {
          console.log(JSON.stringify(error, null, 2));
        },
        onCompleted(response, errors) {
          if (!response.workspace.createRoutine) {
            return;
          }

          props.openRoutineEdit({
            orgWorkspaceId: workspaceId,
            id: response.workspace.createRoutine.id,
            mode: "CREATE",
            createFreq: freq,
            createDailyDaysFilter: "all",
            createDailyStartTimeHour: 8,
            createDailyStartTimeMinute: 0,
          });
        },
      });
    },
    [createRoutineMutation, props, workspaceId]
  );
  const intl_tokens = useIntlTokens();
  const layout = useLayoutContext();
  return (
    <WorkspaceWritable>
      <MoreButton
        items={[
          {
            label: intl_tokens.Daily,
            onPress: () => {
              createRoutine("daily");
            },
            icon: "routine",
          },
          {
            label: intl_tokens.Weekly,
            onPress: () => {
              createRoutine("weekly");
            },
            icon: "routine",
          },

          {
            label: intl_tokens.MonthlyRoutines,
            onPress: () => {
              createRoutine("monthly");
            },
            icon: "routine",
          },
        ]}
        offset={layout.space.small}
      >
        {(open) => (
          <OrgButton
            backgroundColor="primary"
            icon="add"
            tintColor="text-inverted"
            title={intl_tokens.Add}
            onPress={open}
          />
        )}
      </MoreButton>
    </WorkspaceWritable>
  );
}
